import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    description: 'stamps page for account decisions',
    defaultMessage: 'Want to keep your Stamps.com account?',
    id: 'WQlsM7',
  },
  subtitle: {
    description: 'stamps page for account decisions subtitle',
    defaultMessage:
      "Confirm if you'd like to also cancel your Stamps.com account. You can keep your Stamps.com account active with the Stamps Core Plan for {stampsPrice}/month.",
    id: '+EWlct',
  },
  keepMyStamps: {
    description: 'stamps page for account decisions keep Stamps',
    defaultMessage:
      'Only cancel my ShipStation account, but keep my Stamps.com account active with the Stamps Core Plan ({stampsPrice}/month)',
    id: 'S4fQNz',
  },
  saveButton: {
    description: 'stamps page for account decisions keep Stamps',
    defaultMessage: 'Save selection',
    id: '2i/Qu9',
  },
  cancelMyStamps: {
    description: 'stamps page for account decisions cancel Stamps',
    defaultMessage: 'Cancel all accounts',
    id: 'wXwl+M',
  },
  banner: {
    description: 'stamps page for account decisions cancel Stamps banner',
    defaultMessage:
      'To manage this account, visit <a>Stamps.com</a> with username: <b>{username}</b>.{br}{paymentMethod, select, CreditCard {The payment method on file (<b>{paymentMethodName}</b>)} Paypal {The PayPal account on file} other {The payment method on file}} will begin billing on <b>{stampsBillingDate}</b>.',
    id: 'jKxmYf',
  },
});

export default messages;
